import { useCallback, useContext, useState } from 'react';
import { useMutation } from '@apollo/client';

import AuthContext from 'src/contexts/AuthContext';
import { REGISTER_FOR_SALE } from 'src/components/Sales/queries';

const GENERIC_ERROR = 'Registration failed. Please try again.';

// `registered` flips as soon as the mutation lands rather than waiting on the
// refreshed user, so the button reports the outcome without a page refresh.
const useSaleRegistration = saleId => {
  const { registeredSales, refetchCurrentUser } = useContext(AuthContext);
  const [justRegistered, setJustRegistered] = useState(false);
  const [error, setError] = useState(null);
  const [runMutation, { loading: registering }] = useMutation(REGISTER_FOR_SALE);

  const registered = justRegistered ||
    !!registeredSales?.includes(parseInt(saleId));

  const register = useCallback(() => {
    if (registered || registering) { return; }

    setError(null);

    runMutation({ variables: { id: saleId } })
      .then(({ data }) => {
        const failure = data?.createSaleBuyerUser?.errors?.[0];

        if (failure) {
          setError(failure.message);
          return;
        }

        setJustRegistered(true);
        refetchCurrentUser();
      })
      .catch(() => setError(GENERIC_ERROR));
  }, [registered, registering, runMutation, saleId, refetchCurrentUser]);

  return { register, registering, registered, error };
};

export default useSaleRegistration;
